import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import './tailwind.css';   // ✅ import the generated Tailwind CSS


const clerkPublishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
// Debug: print the resolved Clerk publishable key (masked) so we can verify it's loaded
try {
  const masked = clerkPublishableKey
    ? clerkPublishableKey.slice(0, 10) + '...' + clerkPublishableKey.slice(-6)
    : null;
  // eslint-disable-next-line no-console
  console.log('REACT_APP_CLERK_PUBLISHABLE_KEY=', masked);
} catch (e) {
  // ignore
}
const root = ReactDOM.createRoot(document.getElementById('root'));

if (!clerkPublishableKey) {
  root.render(
    <React.StrictMode>
      <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
        <h1>Clerk configuration missing</h1>
        <p>
          The app requires <code>REACT_APP_CLERK_PUBLISHABLE_KEY</code> in your environment.
        </p>
        <p>
          Add it to <code>.env</code> or <code>.env.local</code> and restart the dev server.
        </p>
      </div>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <ClerkProvider publishableKey={clerkPublishableKey} navigate={(to) => window.history.pushState({}, '', to)}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </ClerkProvider>
    </React.StrictMode>
  );
}
